// import React, { Component } from "react";
// import Slider from "react-slick";

// //IMPORT IMAGES
// import avatarImg from '../../frontend/assets/img/testimonial/avatar.png';

// class Testimonial extends Component {
//     constructor(props) {
//         super(props);
//         this.state = {
//             testimonials: []

//         };
//     }
//     componentDidMount() {
//         this.GetTextTestimonialsNoAuth()
//     }
// async GetTextTestimonialsNoAuth() {
//         try {
//             const response = await fetch(`https://absoluteweb.org/myjainism/api/public/v1/texttestimonialswithoutauth`, {
//                 method: "GET",
//                 headers: {
//                     "Content-Type": "application/json",
//                 },
//             });

//             const data = await response.json();
//             if (data) {
//                 this.setState({
//                    testimonials: data?.data
//                 });
//             }
//         } catch (error) {
//             // Handle errors
//             console.error("Error fetching data:", error);
//         }
//     }
//     render() {
//         function SampleNextArrow(props) {
//             const { onClick } = props;
//             return (
//                 <div className="vs-icon-box testi-1 d-none d-lg-block">
//                     <button onClick={onClick} data-slick-prev="#testi1" style={{ marginBottom: 130 }} className="icon-btn style-3 arrow-left"><i
//                         className="far fa-arrow-left"></i></button>
//                 </div>
//             );
//         }

//         function SamplePrevArrow(props) {
//             const { onClick } = props;
//             return (
//                 <div className="vs-icon-box testi-1 d-none d-lg-block">
//                     <button onClick={onClick} data-slick-next="#testi1" className="icon-btn style-3 arrow-right"><i
//                         className="far fa-arrow-right"></i></button>
//                 </div>

//             );
//         }

//         const settings = {
//             infinite: this.state.testimonials.length > 1,
//             dots: this.state.testimonials.length > 1,
//             speed: 500,
//             slidesToShow: 2,
//             slidesToScroll: 2,
//             nextArrow: <SampleNextArrow />,
//             prevArrow: <SamplePrevArrow />,
//             initialSlide: 0,
//             waitForAnimate: false,
//             autoplay: this.state.testimonials.length > 1,
//             autoplaySpeed: 2000,
//             responsive: [
//                 {
//                     breakpoint: 1024,
//                     settings: {
//                         slidesToShow: 2,
//                         slidesToScroll: 2,
//                         infinite: this.state.testimonials.length > 1,
//                         dots: this.state.testimonials.length > 1
//                     }
//                 },
//                 {
//                     breakpoint: 600,
//                     settings: {
//                         slidesToShow: 1,
//                         slidesToScroll: 1,
//                         initialSlide: 1,
//                         infinite: this.state.testimonials.length > 1,
//                         dots: this.state.testimonials.length > 1
//                     }
//                 },
//                 {
//                     breakpoint: 480,
//                     settings: {
//                         slidesToShow: 1,
//                         slidesToScroll: 1,
//                         infinite: this.state.testimonials.length > 1,
//                         dots: this.state.testimonials.length > 1

//                     }
//                 }
//             ]
//         };

        
//         return (
//             <React.Fragment>
//                 <section className="testimonial-section bg-smoke space-top-shape2-plus space-bottom-shape-plus">
//                     <div className="container">
//                         <div className="row gy-30 align-items-center">
//                             <div className="col-lg-4 wow fadeInLeft" data-wow-delay="0.1s">
//                                 <div className="text-center text-lg-start">
//                                     <span className="sub-title">Parent Testimonial</span>
//                                     <h2 className="sec-title">Positive Parents Review Of Us</h2>
//                                     <p className="mb-30">Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem
//                                         Ipsum Lorem Ipsum Lorem Ipsum .</p>

//                                 </div>
//                             </div>
//                             <div className="col-lg-8 wow fadeInRight" data-wow-delay="0.1s">
//                                 <div className="testi-slider-area">
//                                     <div className="row testi-slider vs-carousel" id="testi1" data-slide-show="2">
//                                         <Slider {...settings}>
//                                             {this.state.testimonials.map((testimonial, index) => (
//                                                 <div key={index} className="col-md-6 px-3">
//                                                     <div className="testi-box">
//                                                         <div className="testi-avater">
//                                                             <img src={testimonial.image} alt="testimonial" />
//                                                             <i className="fa-solid fa-quote-left"></i>
//                                                         </div>
//                                                         <h4 className="testi-title">{testimonial.title}</h4>
//                                                         <p className="testi-text">{testimonial.description}</p>
//                                                         <div className="testi-author">
//                                                             <h5 className="name">{testimonial.user_name}</h5>
//                                                             {/* <span className="desig">{testimonial.designation}</span> */}
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             ))}
//                                         </Slider>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </section>
//             </React.Fragment >
//         );
//     }
// }

// export default Testimonial;


import React, { Component } from "react";
import Slider from "react-slick";

//IMPORT IMAGES
import avatarImg from '../../frontend/assets/img/testimonial/avatar.png';
import { BASEURL } from "../../Global";

class Testimonial extends Component {
    constructor(props) {
        super(props);
        this.state = {
            testimonials: []
        };
    }

    componentDidMount() {
        this.GetTextTestimonialsNoAuth();
    }

    async GetTextTestimonialsNoAuth() {
        try {
            const response = await fetch(`${BASEURL}/texttestimonialswithoutauth`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            const data = await response.json();
            if (data) {
                this.setState({
                    testimonials: data?.data
                });
            }
        } catch (error) {
            // Handle errors
            console.error("Error fetching data:", error);
        }
    }

    render() {
        const SampleNextArrow = (props) => {
            const { onClick } = props;
            return (
                <div className="vs-icon-box testi-1 d-none d-lg-block">
                    <button
                        onClick={onClick}
                        data-slick-next="#testi1"
                        className="icon-btn style-3 arrow-right"
                    >
                        <i className="far fa-arrow-right"></i>
                    </button>
                </div>
            );
        };

        const SamplePrevArrow = (props) => {
            const { onClick } = props;
            return (
                <div className="vs-icon-box testi-1 d-none d-lg-block">
                    <button
                        onClick={onClick}
                        data-slick-prev="#testi1"
                        style={{ marginBottom: 130 }}
                        className="icon-btn style-3 arrow-left"
                    >
                        <i className="far fa-arrow-left"></i>
                    </button>
                </div>
            );
        };

        const settings = {
            infinite: this.state.testimonials.length > 1,
            dots: this.state.testimonials.length > 1,
            speed: 500,
            slidesToShow: 2,
            slidesToScroll: 2,
            nextArrow: <SampleNextArrow />,
            prevArrow: <SamplePrevArrow />,
            initialSlide: 0,
            waitForAnimate: false,
            autoplay: this.state.testimonials.length > 1,
            autoplaySpeed: 2000,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        infinite: this.state.testimonials.length > 1,
                        dots: this.state.testimonials.length > 1
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        initialSlide: 1,
                        infinite: this.state.testimonials.length > 1,
                        dots: this.state.testimonials.length > 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: this.state.testimonials.length > 1,
                        dots: this.state.testimonials.length > 1
                    }
                }
            ]
        };

        return (
            <React.Fragment>
                <section className="testimonial-section bg-smoke space-top-shape2-plus space-bottom-shape-plus">
                    <div className="container">
                        <div className="row gy-30 align-items-center">
                            <div className="col-lg-4 wow fadeInLeft" data-wow-delay="0.1s">
                                <div className="text-center text-lg-start">
                                    <span className="sub-title">Parent Testimonial</span>
                                    <h2 className="sec-title">Positive Parents Review Of Us</h2>
                                    {/* <p className="mb-30">Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum.</p> */}
                                </div>
                            </div>
                            <div className="col-lg-8 wow fadeInRight" data-wow-delay="0.1s">
                                <div className="testi-slider-area">
                                    <div className="row testi-slider vs-carousel" id="testi1" data-slide-show="2">
                                        <Slider {...settings}>
                                            {this.state.testimonials.map((testimonial, index) => (
                                                <div key={index} className="col-md-6 px-3">
                                                    <div className="testi-box" style={{minHeight:'500px'}}>
                                                        <div className="testi-avater">
                                                            <img src={testimonial.image || avatarImg} alt="testimonial" />
                                                            <i className="fa-solid fa-quote-left"></i>
                                                        </div>
                                                        <h4 className="testi-title">{testimonial.title}</h4>
                                                        <p className="testi-text">{testimonial.description}</p>
                                                        {/* <div className="testi-author"> */}
                                                            {/* <h5 className="name">{testimonial.user_name}</h5> */}
                                                            {/* <span className="desig">{testimonial.designation}</span> */}
                                                        {/* </div> */}
                                                    </div>
                                                </div>
                                            ))}
                                        </Slider>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </React.Fragment>
        );
    }
}

export default Testimonial;
